import { render } from "./GreenbookCreate.vue?vue&type=template&id=01b651b6&scoped=true"
import script from "./GreenbookCreate.vue?vue&type=script&lang=js"
export * from "./GreenbookCreate.vue?vue&type=script&lang=js"

import "./GreenbookCreate.vue?vue&type=style&index=0&id=01b651b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b651b6"]])

export default __exports__